import { FC } from 'react';
import ClosedMonthDetail from './ClosedMonthDetail';
import UseClosedMonthDetail from './UseClosedMonthDetail';

const ClosedMonthDetailContainer: FC = () => {
  return <ClosedMonthDetail {...UseClosedMonthDetail()} />;
};

export default ClosedMonthDetailContainer;
